import Flickity from 'flickity';

document.addEventListener('DOMContentLoaded', function() {
    const slider = document.getElementById('headeradvert-slider');
    if (slider && slider.children.length > 1) {
        new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            autoPlay: 4000
        });
    }
});
